import React from 'react';
export function Footer() {
  return <footer className="bg-brand-dark text-gray-500 py-6 px-4 border-t-2 border-brand-accent/30" data-id="element-88">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-89">
        <div className="inline-block bg-brand-accent text-brand-dark font-black px-4 py-1.5 rounded-full mb-4 text-xs tracking-widest uppercase shadow-[0_0_15px_rgba(34,197,94,0.4)]" data-id="element-90">
          📘 KIT COMPLETO EDUCACIÓN FINANCIERA LISTA
        </div>

        <p className="text-xs md:text-sm font-bold mb-2 max-w-xl text-gray-400 leading-relaxed" data-id="element-91">
          Hecho por especialistas, para docentes de todo el mundo
          hispanohablante.
        </p>

        <div className="w-full pt-4 mt-2 border-t border-white/5 text-xs md:text-sm text-gray-400 font-bold uppercase tracking-wide" data-id="element-92">
          <p data-id="element-93">
            © 2026 Kit Educación Financiera Lista — Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
}